const Modal = (props) => (
  <div>
    {
      props.isOpen ? (
        <div className={`react-modal-container ${props.className ? props.className : ''}`}>
          <div className='react-modal-opacity' />
          <div className='react-modal'>
            <div className='react-modal_close-button-container'>
              <i className='icon icon--cross close react-modal_close-button' onClick={(e) => { props.onClose(); e.stopPropagation() }} />
            </div>
            {props.children}
          </div>
        </div>
      ) : null
    }
  </div>
)

export default Modal
